import axios from 'axios';
 
const ENVIRONMENT = 'production';

//server toggler
function url() {
    if (ENVIRONMENT === "staging") {
        return "staging.api.ctrlv.ca";
    } else {
        return "api.ctrlv.ca";
    }
}

function mode() {
    if (url() === "staging.api.ctrlv.ca") {
        return STAGING;
    } else {
        return PRODUCTION;
    }
}

const STAGING = 0;
const PRODUCTION = 1;

const dataAPI = {
    getLocations: () => {
        return new Promise((resolve, reject) => {
            axios
                .get(`https://${url()}/api/booking/getAvailableLocations`)
                .then(response => {
                    response.data.result.sort((a, b) => {
                        if(a.displayName < b.displayName) return -1;
                        else if (a.displayName > b.displayName) return 1;
                        else return 0;
                    });

                    resolve(response.data)
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    getConcessionInfo: () => {
        return new Promise((resolve, reject) => {
            axios
                .get(`https://${url()}/api/booking/getExtraLifeTShirtConcessions`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
        })
    },

    holdWebConcessions: (first_name, last_name, email, phone, location_id, concession_id, orderList, shippingInfo, isShipping, recaptcha) => {
        //get array of concession cart items
        const concessionsList = orderList.map(order => {
            return {
                item_fit: order.fit,
                item_size: order.size,
                item_colour: order.colour,
                quantity: Number(order.quantity),
                concession_id: concession_id
            }
        })

        return new Promise((resolve, reject) => {
            axios
                .post(`https://${url()}/api/booking/holdWebConcessions`,
                    {
                        email_address: email,
                        first_name: first_name,
                        last_name: last_name,
                        phone_number: phone,
                        location_id: location_id,
                        concessions: concessionsList
                    }
                )
                .then(response => {
                    //get concession_cart_code from 
                    let concession_cart_code = response.data.result.purchaseCode;
                    let session_token = response.data.result.sessionToken;
                    //if success, continue to next api call, submit form, rather than resolving

                    dataAPI.submitForm(
                        first_name,
                        last_name,
                        email,
                        location_id,
                        concession_cart_code,
                        session_token,
                        shippingInfo,
                        isShipping,
                        orderList,
                        recaptcha
                    );
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    submitForm: async (
        first_name,
        last_name,
        email,
        location_id,
        concession_cart_code,
        session_token,
        shippingInfo,
        isShipping,
        orderList,
        recaptcha
    ) => {

        //should update this with a backend response rather than static values 20 or 0
        let shippingCost = (isShipping) ? 20 : 0;

        return new Promise((resolve, reject) => {
            axios
                .post(`https://${url()}/api/booking/submitExtraLifeTShirtForm`,
                    {
                        location_id: location_id,
                        concession_cart_code: concession_cart_code,
                        address: shippingInfo.address,
                        city: shippingInfo.address,
                        province_state: shippingInfo.provinceState,
                        country: shippingInfo.country,
                        postal_code: shippingInfo.postalCode,
                        shipping: isShipping,
                        shippingCost: shippingCost,
                        items: orderList,
                        recaptcha: recaptcha
                    }
                )
                .then(response => {

                    //elavon payment part
                    // need session_token, purchase_code, emailAddress, firstName, lastName
                    let sessionForm = {
                        ssl_txn_auth_token: session_token,
                        ssl_invoice_number: concession_cart_code,
                        ssl_email: email,
                        ssl_first_name: first_name,
                        ssl_last_name: last_name
                    }

                    var form = document.createElement("form");
                    form.setAttribute("method", "post");
                    if (mode() === PRODUCTION) {
                        form.setAttribute("action", "https://www.convergepay.com/hosted-payments/");
                    } else {
                        form.setAttribute("action", "https://demo.convergepay.com/hosted-payments/");
                    }
                    for (var key in sessionForm) {
                        var hiddenField = document.createElement("input");
                        hiddenField.setAttribute("type", "hidden");
                        hiddenField.setAttribute("name", key);
                        hiddenField.setAttribute("value", sessionForm[key]);
                        form.appendChild(hiddenField);
                    }
                    document.body.appendChild(form);
                    form.submit();

                })
                .catch(error => {
                    console.error(error);
                })
        })
    }


}

export default dataAPI;